export default "__VITE_ASSET__55e9a541__"